const css = `._buttonOrLink_15w4w_1 {
  cursor: pointer;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "buttonOrLink": "_buttonOrLink_15w4w_1"
};